export default {}
export const API_URL = 'https://test.api.blog.funktechno.com/api'



// WEBPACK FOOTER //
// ./src/common/config.js